module.exports = __webpack_public_path__ + "img/plate_photo_3.2c00af64.jpg";